export enum ColorEnum {
    MASK_BG = 'var(--p-mask-background)',
    PRIMARY_COLOR_TEXT = 'var(--p-primary-contrast-color)',
    TEXT_COLOR = 'var(--p-text-color)',
    TEXT_ERROR = 'var(--p-red-500)',
    PRIMARY_COLOR = 'var(--p-primary-color)',
    SECONDARY_COLOR = 'var(--it-secondary-color)',
    PRIMARY_GRADIENT = 'linear-gradient(180deg,var(--p-primary-900) 0%,var(--p-primary-900) 100%)',
    PINK_500 = 'var(--p-pink-500)',
    GRAY_200 = 'var(--p-gray-200)',
    GRAY_300 = 'var(--p-gray-300)',
    SURFACE_0 = 'var(--p-surface-0)',
    SURFACE_300 = 'var(--p-surface-300)',
    VERIFIED = 'var(--p-green-600)',
    TRANSPARENT = 'transparent',
    WHITE = 'var(--neutral)',
    WHITE_OVERLAY_20 = 'var(--white-overlay-20)',
    WHITE_OVERLAY_30 = 'var(--white-overlay-30)',

    // Primary Colors
    NIGHT = 'var(--night)',
    NIGHT_GRADIENT = 'linear-gradient(41deg, #5D40B2 5.86%, #3D2584 94.48%)',
    ASPHALT = 'var(--asphalt)',
    BLUE = 'var(--blue)',
    BLUE_GRADIENT = 'linear-gradient(37deg, #0058FF 8.7%, #033696 149.74%)',
    GREEN = 'var(--green)',
    GREEN_GRADIENT = 'linear-gradient(223deg, #35C591 6.18%, #4AF5B8 97.76%)',

    // Secondary Colors
    PURPLE = 'var(--purple)',
    ORANGE = 'var(--orange)',
    RED = 'var(--red)',
    TARMAC = 'var(--tarmac)',

    // Blue Shades
    BLUE_100 = 'var(--blue-100)',
    BLUE_200 = 'var(--blue-200)',
    BLUE_300 = 'var(--blue-300)',
    BLUE_400 = 'var(--blue-400)',
    BLUE_500 = 'var(--blue-500)',
    BLUE_600 = 'var(--blue-600)',
    BLUE_700 = 'var(--blue-700)',
    BLUE_800 = 'var(--blue-800)',
    BLUE_900 = 'var(--blue-900)',

    // Green Shades
    GREEN_100 = 'var(--green-100)',
    GREEN_200 = 'var(--green-200)',
    GREEN_300 = 'var(--green-300)',
    GREEN_400 = 'var(--green-400)',
    GREEN_500 = 'var(--green-500)',
    GREEN_600 = 'var(--green-600)',
    GREEN_700 = 'var(--green-700)',
    GREEN_800 = 'var(--green-800)',
    GREEN_900 = 'var(--green-900)',

    // Purple Shades
    PURPLE_100 = 'var(--purple-100)',
    PURPLE_200 = 'var(--purple-200)',
    PURPLE_300 = 'var(--purple-300)',
    PURPLE_400 = 'var(--purple-400)',
    PURPLE_500 = 'var(--purple-500)',
    PURPLE_600 = 'var(--purple-600)',
    PURPLE_700 = 'var(--purple-700)',
    PURPLE_800 = 'var(--purple-800)',
    PURPLE_900 = 'var(--purple-900)',

    // Orange Shades
    ORANGE_100 = 'var(--orange-100)',
    ORANGE_200 = 'var(--orange-200)',
    ORANGE_300 = 'var(--orange-300)',
    ORANGE_400 = 'var(--orange-400)',
    ORANGE_500 = 'var(--orange-500)',
    ORANGE_600 = 'var(--orange-600)',
    ORANGE_700 = 'var(--orange-700)',
    ORANGE_800 = 'var(--orange-800)',
    ORANGE_900 = 'var(--orange-900)',

    // Night Shades
    NIGHT_100 = 'var(--night-100)',
    NIGHT_200 = 'var(--night-200)',
    NIGHT_300 = 'var(--night-300)',
    NIGHT_400 = 'var(--night-400)',
    NIGHT_500 = 'var(--night-500)',

    // Red Shades
    RED_100 = 'var(--red-100)',
    RED_200 = 'var(--red-200)',
    RED_300 = 'var(--red-300)',
    RED_400 = 'var(--red-400)',
    RED_500 = 'var(--red-500)',
    RED_600 = 'var(--red-600)',
    RED_700 = 'var(--red-700)',
    RED_800 = 'var(--red-800)',
    RED_900 = 'var(--red-900)',

    // Neutral Shades
    NEUTRAL_50 = 'var(--neutral-50)',
    NEUTRAL_70 = 'var(--neutral-70)',
    NEUTRAL_100 = 'var(--neutral-100)',
    NEUTRAL_200 = 'var(--neutral-200)',
    NEUTRAL_300 = 'var(--neutral-300)',
    NEUTRAL_400 = 'var(--neutral-400)',
    NEUTRAL_500 = 'var(--neutral-500)',
    NEUTRAL_600 = 'var(--neutral-600)',
    NEUTRAL_700 = 'var(--neutral-700)',
    NEUTRAL_800 = 'var(--neutral-800)',
    NEUTRAL_900 = 'var(--neutral-900)',

    // Inty AI Colors
    INTY_CYAN = 'var(--inty-cyan)',
    INTY_GREEN = 'var(--inty-green)',
}
